import React, {useEffect, useMemo} from 'react';
import {MeshType} from 'api/generated';
import {Mesh} from 'three';
import {useGLTF} from '@react-three/drei';

interface IARModelGLTFProps {
  data: MeshType;
  onLoad?: () => void;
}

const ARModelGLTF = (props: IARModelGLTFProps) => {
  const {data, onLoad} = props;
  const gltf = useGLTF(data.fileUrl!);
  const object = useMemo(() => gltf.scene.clone(), [gltf]);

  useEffect(() => {
    object.traverse(o => {
      if ((o as Mesh).isMesh) {
        o.castShadow = true;
      }
    });
    onLoad?.();
  }, [object]);

  return <primitive object={object} />;
};

export default React.memo(ARModelGLTF);
